export const ACCOUNT_MANAGES_USER_LIFECYCLE =
  process.env.NEXT_PUBLIC_ACCOUNT_MANAGES_USER_LIFECYCLE === "true";
